<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>职位管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="" style="margin-left: -100px;">
          <el-col :span="5" style="display: none;">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%;">
              <el-option label="职位名" value="role_name"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px;">
            <el-input placeholder="请输入职位名称" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div>
          <el-button icon="el-icon-plus" @click="showNew()" v-if="NodeInclude('206')">创建职位</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="dep_id" label="部门" header-align="center" align="center" min-width="80">
          <template slot-scope="scope">
            <div>{{departList.find(item => item.id === scope.row.dep_id)?.en_name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="role_name" label="职位名称" header-align="center" align="center" min-width="150" />
        <el-table-column prop="user_count" label="分配人数" header-align="center" align="center" min-width="150" />
        <el-table-column prop="user" label="分配用户列表" header-align="center" align="center" min-width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.user.length"><span v-for="(v, i) in scope.row.user" :key="`user_${i}`">{{ v.realname }}{{
              v.en_name }} </span></div>
            <div v-else>暂无</div>
          </template>
        </el-table-column>
        <el-table-column prop="mark" label="备注" header-align="center" align="center" min-width="200" />
        <el-table-column prop="create_time" label="创建时间" header-align="center" align="center" min-width="150" />
        <el-table-column prop="id" label="操作" width="150" header-align="center" align="center" fixed="right" v-if="NodeInclude('206') || NodeInclude('207') || NodeInclude('208')">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="handleCopy(scope.row)" v-if="NodeInclude('208')">复制职位</el-link>
              <el-link type='primary' class="link" @click="handleClick(scope.row)" v-if="NodeInclude('206')">编辑</el-link>
              <el-link type='primary' class="link" @click="handleDel(scope.row)" v-if="NodeInclude('207')">删除</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="基本信息" :visible.sync="newShow" width="500px">
      <el-form ref="newForm" :model="newForm" label-width="0" label-position="left" class="ulform">
        <el-form-item label="" prop="role_name">
          <el-col :span="24">
            <el-input placeholder="请输入职位名称" maxlength="50" v-model="newForm.role_name" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="" prop="mark">
          <el-col :span="24">
            <el-input placeholder="请输入职位备注或说明" type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
              v-model="newForm.mark" clearable />
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="newShow = false">取 消</el-button>
        <el-button type="primary" @click="toDetail()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="删除提醒" :visible.sync="delShow" width="600px">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>您是否确认删除“{{ delForm.role_name }}”职位？</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delShow = false">取 消</el-button>
        <el-button type="primary" @click="confirmDel">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="职位不可删除" :visible.sync="cannotDelShow" width="600px">
      <ul class="aul" style="padding:0">
        <li>
          <div>如要删除“{{ delForm.role_name }}”职位？</div>
          <div>需要先给使用该职位的用户分配新的职位</div>
        </li>
        <li class="dialog-table">
          <div v-for="(v, i) in delForm.user" :key="`use_${i}`">
            <div>{{ v.realname }} {{ v.en_name }}</div>
            <div class="dtbtn" @click="toAuthor(v)">重新分配职位</div>
          </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cannotDelShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from '@/api'
import store from '@/store'
export default {
  name: 'role',
  data() {
    return {
      nodeLimtList: [],
      departList: [],
      itemList: [],
      total: 0,
      p: 1,
      perPage: 30,
      form: {
        status: '',
        atype: 'role_name',
      },
      newShow: false,
      newForm: {
        role_name: '',
        mark: '',
      },
      delShow: false,
      delForm: {
        del_str: '',
        role_name: '',
      },
      cannotDelShow: false,
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.type[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  mounted() {
    this.getStoreFn()
    this.getDepartList();
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    async getDepartList() {
      return new Promise((resolve) => {
        this.$fly
          .post('apiAccount_getDepartmentList.html', {

          })
          .then((res) => {
            this.departList = res
            resolve(res)
          })
      })
    },
    showNew() {
      this.newForm = {
        role_name: '',
        mark: '',
      }
      this.newShow = true
    },
    toDetail() {
      if (!this.newForm.role_name) {
        this.$message.error('请填写职位名')
        return false
      }
      this.$fly.post('ApiRole_addOrUpdateRole.html',
        {
          option: 1,
          ...this.newForm
        }).then((res) => {
          this.newShow = false
          this.$message.success('success')
          this.$router.push({
            path: '/role/detail',
            query: { id: res.role_id },
          })
        })
    },
    handleCopy(item) {
      this.$router.push({
        path: '/role/detail',
        query: { id: item.id, type: '2', },
      })
    },
    handleClick(item) {
      this.$router.push({
        path: '/role/detail',
        query: { id: item.id, type: '1', },
      })
    },
    handleDel(item) {
      const { id, role_name, user } = item
      this.delForm = {
        del_str: id,
        role_name,
        user,
      }
      if (this.delForm.user.length) {
        this.cannotDelShow = true
      }
      else {
        this.delShow = true
      }
    },
    confirmDel() {
      if (this.delForm.user.length) {
        this.cannotDelShow = true
        return false
      }
      this.$fly.post('ApiRole_delRole.html',
        {
          del_str: this.delForm.del_str,
        }).then(() => {
          this.delShow = false
          this.del_str = ''
          this.$message.success('success')
          this.getList()
        })
    },
    toAuthor(item) {
      this.cannotDelShow = false
      this.$router.push({
        path: '/author/build',
        query: { id: item.id, type: 1 },
      })
    },
    search() {
      this.p = 1
      store.commit('setRoleData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
    getStoreFn() {
      this.form = Object.keys(store.state.roleData).length != 0 ? store.state.roleData : this.form
      this.getList()
    },
    getList(option = {}) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const postData = {
        p: this.p,
        per_page: this.perPage,
        ...this.form,
        [this.form.atype]: this.form.key,
        ...option,
      }
      this.$fly.post('ApiRole_getRoleList.html', postData).then((res) => {
        this.itemList = res.itemList.filter((item) => item.id != 1)
        this.total = +res.totalNum
      })
    },
    removeTag(tag) {
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      store.commit('setRoleData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
    handleCurrentChange(p) {
      this.p = p
      store.commit('setRoleData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;

  .filter {
    width: 85%;
  }

  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}

.dialog-table {
  padding: 40px 100px 0;

  >div {
    margin-bottom: 20px;
    @extend %start;
    justify-content: space-between;

    .dtbtn {
      cursor: pointer;
      border-bottom: 0.2px solid transparent;

      &:hover {
        border-bottom: 0.2px solid #606266;
      }
    }
  }
}</style>
